import { NgModule, Optional, SkipSelf } from '@angular/core';

// components/directives/pipes

import { ProfileFeatureModule } from '@amfam/profile/feature';

// application modules
import { SharedModule } from '../shared/shared.module';
import { PostEnrollmentGopaperlessComponent } from './containers/post-enrollment-gopaperless/post-enrollment-gopaperless.component';

@NgModule({
  imports: [SharedModule, ProfileFeatureModule],
  declarations: [PostEnrollmentGopaperlessComponent]
})
export class ProgramModule {
  constructor(@Optional() @SkipSelf() parentModule: ProgramModule) {
    if (parentModule) {
      throw new Error('ProgramModule is already loaded');
    }
  }
}
